<template>
  <div class="loading-backdrop"  :class="[isWaiting ? 'show' : 'hide']">
    <div>
        <img src="../assets/loading.gif" alt="Loading" />
   </div>
  </div>
</template>

<script>
import HttpEventPublisher, { HttpEventSubscriber } from '../shared/http-event-publisher';

export default {
  name: 'OverDropUi',
  created() {
    HttpEventPublisher.subscribe(new HttpEventSubscriber(this.onHttpRequest, this.onHttpResponse));
  },
  data() {
    return {
      pendingRequestCount: 0,
    };
  },
  computed: {
    isWaiting() {
      return (this.pendingRequestCount > 0);
    },
    isUserLogged() {
      return !!this.$store.getters.loggedUser;
    },
  },

  methods: {
    onHttpRequest() {
      this.pendingRequestCount += 1;
    },
    onHttpResponse() {
      if (this.pendingRequestCount !== 0) this.pendingRequestCount -= 1;
    },
  },
};
</script>
<style >
.loading-backdrop {
    width: 100% !important;
    height: 100%;
    background: #014fd52a;
    position: absolute;
    z-index: 1001;
    color: white;
    text-align: center;
    padding: 34px;
    background-size: cover;
  overflow: hidden;
}
.loading-backdrop>div {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.show {
 display: block;
}
.hide {
  display: none;
}
</style>
